<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>LIBRARY</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Library</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section>
    <div class="container">
        <div class="section-heading text-start mb-0 text-center">
            <span class=" sub-title">All are Fully Wi-Fi Blocks</span>
        </div>
        <h2 class="text-center">LIBRARY Facilities</h2>
        <p>The University Library has been up-graded to the Best Library in the state of Himachal Pradesh and in the
            entire surrounding areas. It has now approx 28000 books of different streams , has facilities of e-journals
            and is fully air-conditioned to provide ideal environment for the students. The Library has a large number
            of national and international journals in the field of Management, Technology, Science and Arts.</p>
        <div class="section-heading text-start mb-0 text-center">
            <span class=" sub-title">Related Links</span>
        </div>
        <ul>
            <li><a href="https://www.ugc.gov.in/ErrorPage/index?code=404" target="_blank">e-Books@UGC Portal</a></li>
            <li><a href="https://nptel.ac.in/" target="_blank">NPTEL (Home Page)</a></li>
            <li><a href="https://ndl.iitkgp.ac.in/" target="_blank">NDL</a></li>
            <li><a href="http://shodhganga.inflibnet.ac.in/" target="_blank">Shodhganga</a></li>
            <li><a href="https://www.delnet.in/" target="_blank">Delnet</a></li>
        </ul>
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12 mt-5">
                <img src="assets/img/hostel/lib1.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12 mt-5">
                <img src="assets/img/hostel/lib2.jpg" class="cover-background w-100 h-100"/>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-12 mt-5">
                <img src="assets/img/hostel/lib3.jpg" class="cover-background w-100 h-100"/>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12 mt-5">
                <img src="assets/img/hostel/lib4.jpg" class="cover-background w-100 h-100"/>
            </div>
        </div>
    </div>
</section>
